import React, { useContext, useEffect, useState } from "react";
import "./style/ScriptBox.scss";
import AppContext from "../../context/appContext";
import RoundCloseButton from "../RoundCloseButton/RoundCloseButton";
import CloseIcon from "../VectorIcons/CloseIcon";

const ScriptBox = (props) => {
  const [stateBox, setStateBox] = useState({ open: false });
  const context = useContext(AppContext);

  const {
    title,
    children,
    clear,
    icon,
    size,
    removePadding,
    allowOverflow,
    resizeHeader,
    marginBottom,
    contentBg,
    newHeader,
  } = props;

  useEffect(() => {
    setTimeout(() => {
      setStateBox({ open: props.open });
    }, 100);
  }, [props.open]);

  const _closed = () =>
    typeof clear === "function" ? clear() : context.setCurrentStepBox("closed");

  const contentStyle =
    contentBg && (contentBg.startsWith("#") || contentBg.startsWith("rgb"))
      ? { backgroundColor: contentBg }
      : {};

  const contentClass =
    contentBg && !(contentBg.startsWith("#") || contentBg.startsWith("rgb"))
      ? contentBg
      : "";

  return (
    <div
      className={`ScriptBox ${stateBox.open ? "active" : ""} ${
        !!size ? size : ""
      }`}
    >
      <div className="bgScriptBox" />
      <div className="windowScriptBox">
        {newHeader ? (
          <div className="newHeader">
            <h2>{title}</h2>
            <div className="closeIcon" onClick={() => _closed()}>
              <CloseIcon color={"#808080"} />
            </div>
        </div>
        ) : (
          <div className={`header ${resizeHeader ? "resizeHeader" : ""}`}>
            {icon}
            <h2>{title}</h2>
            <div className="closeIcon" onClick={() => _closed()}>
              <RoundCloseButton />
            </div>
          </div>
        )}

        <div
          className={`content
            ${removePadding ? "removePadding" : ""}
            ${allowOverflow ? "allowOverflow" : ""}
            ${marginBottom ? "marginBottom" : ""}
            ${contentClass}  /* classe opcional */
          `}
          style={contentStyle}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ScriptBox;
